var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-form",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            {
              staticClass: "pb-0",
              attrs: {
                cols: "12",
                md: "6"
              }
            },
            [
              _c("gg-input-label", [_vm._v("Path")]),
              _c("v-text-field", {
                ref: "pathField",
                staticClass: "gg-input gg-prepend",
                attrs: {
                  outlined: "",
                  dense: "",
                  autocomplete: "off",
                  name: "Path"
                },
                scopedSlots: _vm._u([
                  {
                    key: "prepend-inner",
                    fn: function fn() {
                      return [
                        _c(
                          "div",
                          {
                            staticClass: "prepend-bg"
                          },
                          [
                            _c("domain-select", {
                              style: {
                                minWidth: "180px",
                                width: "".concat(_vm.domainWidth, "px"),
                                maxWidth: "250px"
                              },
                              attrs: {
                                "no-label": "",
                                "hide-details": "",
                                flat: "",
                                solo: ""
                              },
                              on: {
                                "domain-type-selected": _vm.domainTypeSelected
                              },
                              model: {
                                value: _vm.domain,
                                callback: function callback($$v) {
                                  _vm.domain = $$v
                                },
                                expression: "domain"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    },
                    proxy: true
                  }
                ]),
                model: {
                  value: _vm.path,
                  callback: function callback($$v) {
                    _vm.path = $$v
                  },
                  expression: "path"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            {
              staticClass: "pb-0",
              attrs: {
                cols: "12",
                md: "6"
              }
            },
            [
              _c(
                "gg-input-label",
                [
                  _vm._v(" Auth Name "),
                  _c(
                    "v-tooltip",
                    {
                      attrs: {
                        bottom: ""
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function fn(_ref) {
                            var on = _ref.on
                            return [
                              _c(
                                "v-icon",
                                _vm._g(
                                  {
                                    attrs: {
                                      color: "primary",
                                      small: ""
                                    }
                                  },
                                  on
                                ),
                                [_vm._v(" mdi-help-circle ")]
                              )
                            ]
                          }
                        }
                      ])
                    },
                    [
                      _c("span", [
                        _vm._v(
                          "This is what will appear on the browser when the password is prompted."
                        )
                      ])
                    ]
                  )
                ],
                1
              ),
              _c("gg-text-field", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                attrs: {
                  "data-vv-name": "authname",
                  "data-vv-as": "Auth Name",
                  "error-messages": _vm.errors.collect("authname")
                },
                model: {
                  value: _vm.authname,
                  callback: function callback($$v) {
                    _vm.authname = $$v
                  },
                  expression: "authname"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            {
              staticClass: "pt-0",
              attrs: {
                cols: "12"
              }
            },
            [
              _c(
                "gg-btn",
                {
                  attrs: {
                    loading: _vm.loading
                  },
                  on: {
                    click: _vm.create
                  }
                },
                [_vm._v("Create")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }